"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Video = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var sources = _ref.sources,
      classes = _ref.classes,
      id = _ref.id,
      loop = _ref.loop,
      muted = _ref.muted,
      playsInline = _ref.playsInline,
      controls = _ref.controls,
      videoProps = _ref.videoProps,
      fluid = _ref.fluid;
  return sources && sources.length ? /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: (0, _scss.cls)(fluid && 'img-fluid', classes === null || classes === void 0 ? void 0 : classes.wrapper),
    dangerouslySetInnerHTML: {
      __html: "\n            <video preload=\"auto\" ".concat(id ? "id=\"".concat(id, "\"") : '', " class=\"").concat((0, _scss.cls)(fluid && 'img-fluid', classes === null || classes === void 0 ? void 0 : classes.video), "\" ").concat(loop ? 'loop' : '', " ").concat(muted ? 'muted' : '', " ").concat(playsInline ? 'playsinline' : '', " ").concat(controls ? 'controls' : '', " ").concat(videoProps ? videoProps : '', ">\n                ").concat(sources.map(function (s) {
        return "\n                    <source\n                        src=\"".concat(s.src, "\"\n                        type=\"video/").concat(s.type, "\"\n                    />\n                ");
      }), "\n            </video>")
    }
  }) : null;
});
var _default = Video;
exports["default"] = _default;